import { Fragment } from "react";

import { FormGroup, SelectField } from "@bokio/designsystem/components/Form";

import {
	getAccountingTypeOptions,
	getAccountingTypeSelectLabelText,
	getVisibleAccountingTypeOptions,
} from "./vatSettingAccountingTypeInputHelpers";

import type { VatSettingAccountingTypeInputState } from "./vatSettingAccountingTypeInputHelpers";
import type * as m from "@bokio/mobile-web-shared/core/model/model";
import type { FiscalYearValidator } from "@bokio/settings/src/scenes/FiscalYears/fiscalYearValidator";
import type { ValidatorResult } from "@bokio/shared/validation/entityValidator";
import type { ReactNode } from "react";

export type VatSettingAccountingTypeInputProps = {
	state: VatSettingAccountingTypeInputState;
	company: m.Settings.Controllers.CompanyInfoForView;
	onStateChange: (state: VatSettingAccountingTypeInputState) => void;
	accountingTypeDescription?: ReactNode;
	validator?: FiscalYearValidator;
	validation?: ValidatorResult;
};

const VatSettingAccountingTypeInput = ({
	company,
	state,
	onStateChange,
	accountingTypeDescription,
	validator,
	validation,
}: VatSettingAccountingTypeInputProps) => {
	return (
		<Fragment>
			<FormGroup
				hidden={
					getVisibleAccountingTypeOptions(
						company.Country,
						company.CompanyType,
						state.vatSetting,
						company.CountryMetadata.RulesByCompanyTypeAndVatSetting,
					).length <= 1
				}
			>
				<SelectField
					label={getAccountingTypeSelectLabelText(company.Country, company.CompanyType, state.vatSetting)}
					testId="InitialFiscalYearInput_AccountingType_Select"
					labelTestId="InitialFiscalYearInput_AccountingType_Label"
					value={state.accountingType}
					onChange={val => onStateChange({ ...state, accountingType: val })}
					options={getAccountingTypeOptions(
						company.Country,
						company.CompanyType,
						state.vatSetting,
						company.CountryMetadata.RulesByCompanyTypeAndVatSetting,
					)}
					errors={validator && validation && validator.filterByField("AccountingForm", validation.errors)}
				/>
				{accountingTypeDescription}
			</FormGroup>
		</Fragment>
	);
};

export default VatSettingAccountingTypeInput;
